export default __webpack_public_path__ + "18b9cb6a7cc6b3cc0c5034d5cf6d6f26.svg";